import { memo } from 'react';
import { Box } from '@chakra-ui/react';

import { neutral } from '../planPageRevampUi';

import RevampInputSection from './RevampInputSection';

interface Properties {
  refetchRequest: () => void;
}

const DriverInputPanel = ({ refetchRequest }: Properties) => (
  <Box
    h='100%'
    flex='1'
    minW={0}
    bg={neutral.surface}
    borderRight='1px solid'
    borderColor={neutral.border}
    overflow='hidden'
    display='flex'
    flexDirection='column'
  >
    <RevampInputSection refetchRequest={refetchRequest} />
  </Box>
);

export default memo(DriverInputPanel);
